export class FetchUsersReportDetails {
    static readonly type = '[User] FetchUsersReportDetails';

    constructor(public jobId: string) {}
}
